// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a63103d","453":"e7f16667","732":"21f98bb1","977":"fb0699de"}[chunkId] + ".chunk.js";
};